import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children, requireRole }){
  const token = localStorage.getItem("token");
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // optional role enforcement
  if (requireRole) {
    const role = localStorage.getItem("role") || "";
    if (role !== requireRole) {
      // user is logged in but not allowed
      return <Navigate to="/login" replace />;
    }
  }

  return children;
}
